export const LIST_DELETE_SUCCESS = 'LIST_DELETE_SUCCESS'
export const LISTS_GET_SUCCESS = 'LISTS_GET_SUCCESS'
